
import { Chart } from 'chart.js';

import CPMoney from '@/components/globals/forms/CPMoney.vue';
import CPSkeletonLoader from '@/components/globals/CPSkeletonLoader.vue';

import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  components: {
    CPSkeletonLoader,
    CPMoney,
  },
})
export default class CPProjections extends Vue {

  public get projectionDetails() { return this.$store.state.utils.projectionDetails; }

  public get referenceCurrency() {
    return this.$store.state.account.details.role.includes('consultant') ?
    this.$store.state.consultantDefaultCurrency.Currency :
    this.$store.state.account.details.activeAccount.currency;
  }

  public get referenceCurrencySymbol() {
    return this.$store.state.account.details.role.includes('consultant') ?
    this.$store.state.consultantDefaultCurrency.CurrencySymbol :
    this.$store.state.account.details.activeAccount.currencySymbol;
  }

  public get projections() { return this.$store.state.utils.projections.length > 0 ? this.$store.state.utils.projections[0] : null; }


  public get projectionsSorted() { return this.projections ? [
    {
      id: 1,
      name: 'One Year',
      amount: this.projections.OneYear,
    },
    {
      id: 2,
      name: 'Two Years',
      amount: this.projections.TwoYear,
    },
    {
      id: 3,
      name: 'Three Years',
      amount: this.projections.ThreeYear,
    },
    {
      id: 4,
      name: 'Four Years',
      amount: this.projections.FourYear,
    },
    {
      id: 5,
      name: 'Five Years',
      amount: this.projections.FiveYear,
    },
    {
      id: 6,
      name: 'Six Years',
      amount: this.projections.SixYear,
    },
    {
      id: 7,
      name: 'Seven Years',
      amount: this.projections.SevenYear,
    },
    {
      id: 8,
      name: 'Eight Years',
      amount: this.projections.EightYear,
    },
    {
      id: 9,
      name: 'Nine Years',
      amount: this.projections.NineYear,
    },
    {
      id: 10,
      name: 'Ten Years',
      amount: this.projections.TenYear,
    },
    {
      id: 11,
      name: 'Eleven Years',
      amount: this.projections.ElevenYear,
    },
    {
      id: 12,
      name: 'Twelve Years',
      amount: this.projections.TwelveYear,
    },
    {
      id: 13,
      name: 'Thirteen Years',
      amount: this.projections.ThirteenYear,
    },
    {
      id: 14,
      name: 'Fourteen Years',
      amount: this.projections.FourteenYear,
    },
    {
      id: 15,
      name: 'Fifteen Years',
      amount: this.projections.FifteenYear,
    },
  ] : null; }

  get projectionsLabelsAll() {
    return this.projectionsSorted ? this.projectionsSorted.map((element) => element.name ) : null;
  }
  get projectionsLabels() {
    return this.projectionsSorted ? this.projectionsSorted.map((element) => element.id % 5 === 0 || element.id === 1 ? element.name : ' ' ) : null;
  }
  get projectionsData() {
    return this.projectionsSorted ? this.projectionsSorted.map((element) => element.amount) : null;
  }

  public activeStep: number = 1;
  public loaded: boolean = false;
  public loading: boolean = false;

  public currentValue: number | null = null;
  public rateOfReturn: number | null = null;
  public additionalContribution: number | null = null;

  public colours = [
    '#1F2041',

  ];

  // Line Chart via Chart.js

  // Chart Data
  public chartEl: any = null;

  public myChart: any;
  public chart = this.$refs.chart;

  public title: string = 'Yearly Performance';

  public getProjections() {
    this.loading = true;
    if (!this.rateOfReturn) {
      this.rateOfReturn = 0;
    }
    if (!this.additionalContribution) {
      this.additionalContribution = 0;
    }
    this.$store.dispatch('getProjections', {
      expRatedOfReturn: this.rateOfReturn,
      yearlyContribution: this.additionalContribution,
      currentValue: this.projectionDetails.value,
      baseCurrency: this.projectionDetails.currency,
      referenceCurrency: this.referenceCurrency,
    });
  }

  @Watch('projections', {deep: true})
  public async rerunChart() {
    if (this.myChart) {
      this.myChart.data.datasets.pop(0);
      this.myChart.data.datasets.push({
        // label: this.projectionsLabelsAll,
        data: this.projectionsData ? this.projectionsData : [],
        pointRadius: 0.5,
        pointHitRadius: 10,
        pointHoverRadius: 10,
        borderColor: this.colours[0],
        borderWidth: 3,
        lineTension: 0.1,
        backgroundColor: this.colours[0] + '44',
      });
      this.myChart.update();

      setTimeout(() => {
        this.loading = false;
      }, 500);
    } else {
      this.createLineChart();
    }
  }
  public createLineChart() {
    this.myChart = new Chart(this.chartEl, {
      type: 'line',
      data: {
        labels: this.projectionsLabels ? this.projectionsLabels : [],
        datasets: [
          {
            // label: this.projectionsLabelsAll,
            data: this.projectionsData ? this.projectionsData : [],
            pointRadius: 0.5,
            pointHitRadius: 10,
            pointHoverRadius: 10,
            borderColor: this.colours[0],
            borderWidth: 3,
            lineTension: 0.1,
            backgroundColor: this.colours[0] + '44',
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: 1.65,
        animation: {
          duration: 1500,
          easing: 'easeInOutCubic',
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [{
            ticks: {
              fontSize: 11,
              callback(label, index, labels) {
                return '$' + label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              },
            },
          }],
          xAxes: [{
            ticks: {
              fontSize: 11,
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0,

            },
          }],
        },
        tooltips: {
           mode: 'label',
           callbacks: {
            label(tooltipItem: any, data) {
                return '$' + tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
          },
        },
      },
    });
    this.myChart.update();
    this.loaded = true;
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }

  public mounted() {
    this.chartEl = this.$refs.chart;
  }
  public beforeDestroy() {
    this.$store.commit('setProjections', []);
  }


}
